module.exports = __webpack_public_path__ + "img/Frame 792one.ba810f18.png";